import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useTranslation } from "react-i18next";
import { Pagination, SearchInput } from "ui";

import { TransactionsTable, TransactionsTableFilter } from "../../components";
import { useTransactionsList } from "../../hooks";

import styles from "./Transactions.module.scss";

const Transactions = () => {
  const { t } = useTranslation();

  const {
    value: isFilterModalOpen,
    toggle: toggleFilterModal,
    setFalse: onCloseFilterModal
  } = useBoolean(false);

  const {
    transactions,
    totalItems,
    searchValue,
    sorting,
    setSearchValue,
    setSorting,
    page,
    setPage,
    isLoading
  } = useTransactionsList();

  return (
    <ContentLayout title={t("Transactions")}>
      <BoxShadowLayout className={styles.transactions}>
        <div className={styles.transactions__header}>
          <SearchInput
            value={searchValue}
            onChange={setSearchValue}
            placeholder={t("Search...")}
          />

          <TransactionsTableFilter
            isLoading={false}
            isOpen={isFilterModalOpen}
            onClose={onCloseFilterModal}
            onToggle={toggleFilterModal}
          />
        </div>

        <TransactionsTable
          transactions={transactions ?? []}
          sorting={sorting}
          setSorting={setSorting}
          isLoading={isLoading}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default Transactions;
